import channels from './channels.json';
import methods from './methods.json';
import filters from './filters.json';


export const matrix_data = {
    channels: channels,
    filters: filters,
    methods: methods
};